import EditRubricForm from 'components/Rubrics/EditRubricForm';
import { useLocation } from 'react-router-dom';
import { Container, Stack, styled, Text } from 'shell/components';

const Mobile = ({ form, setForm, errors, setErrors, hasClickedSubmit, validateTitle, validateCriteria }) => {
    const location = useLocation();
    const [mode] = location.pathname.split('/').slice(-1);

    return (
        <CustomContainer device={'mobile'}>
            <RootStack spacing={3}>
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    {mode === 'edit' ? 'Edit' : 'Create'} a Rubric
                </Text>
                <EditRubricForm
                    form={form}
                    setForm={setForm}
                    errors={errors}
                    setErrors={setErrors}
                    hasClickedSubmit={hasClickedSubmit}
                    validateTitle={validateTitle}
                    validateCriteria={validateCriteria}
                />
            </RootStack>
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(({ theme }) => {
    return {
        paddingBottom: theme.spacing(5),
    };
});

const RootStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

export default Mobile;
